import InputField from 'lib/input'
import React from 'react'
import Button from 'lib/button'
import Fetch from 'lib/fetch'

const AddUserForm = ({ model, mutate }) => {
  const update = (updates) => {
    model.draftUser = { ...model.draftUser, ...updates }
  }

  const addUser = () => {
    model.savingUser = true
    Fetch('/permitted-users', {
      method: 'POST',
      body: JSON.stringify({
        permitted_user: model.draftUser,
      }),
    }).then((response) => {
      if (response.ok) {
        response.json().then((user) => {
          model.draftUser = {}
          if (mutate) mutate()
          model.savingUser = false
          model.addingUser = false
          model.permittedUsers = [...model.permittedUsers, user.id]
        })
      } else {
        model.savingUser = false
        response
          .json()
          .then((body) => alert('An error occurred ' + body.errors))
      }
    })
  }

  return (
    <div className="flex flex-col space-y-2 text-sm ml-5 my-2 px-3 py-2 border border-mimic-light-brown rounded-md">
      <div className="text-sm font-semibold">Add a new permitted user</div>
      <div className="flex flex-row items-end w-full space-x-3">
        <InputField
          label="Email"
          value={model.draftUser.email}
          onChange={(newName) => update({ email: newName })}
          containerClassName="w-full"
          disabled={model.savingUser}
        />
        <Button
          label="Add user"
          onClick={addUser}
          className="text-xs disabled:opacity-50 whitespace-nowrap"
          disabled={!model.draftUserOK || model.savingUser}
        />
      </div>
    </div>
  )
}

export default AddUserForm
